import React from 'react';

import Logo from '../images/tvw-logo.png';

const Welcome = () => {
  return (
    <div className="row">
      <div className="col-md-10 offset-md-1 jh-content">
        <h1>Herzlich Willkommen</h1>
        <p><span style={{color: "#014c72"}}>startbereit</span> ist die Anmeldeplattform des Zeitmessteams TV Weiler i.d.B., über die wir das Anmelden zu Sportveranstaltungen für Sportler und Trainer vereinfachen und schneller machen möchten. Das Ziel von <span style={{color: "#014c72"}}>startbereit</span> ist, dass ihr euch voll und ganz auf euren Sport konzentrieren könnt und möglichst wenig Zeit durch einfache Formulare und einen schnellen Anmeldeprozess benötigt wird. Und keine Angst - es wird kein extra Benutzerkonto benötigt, um sich für eine Veranstaltung anzumelden.</p>

        <p>Falls ihr Fragen oder Verbesserungsvorschläge habt, scheut euch nicht uns zu schreiben oder direkt anzusprechen. Wir freuen uns über jede Nachricht an zeitmessteam[at]tv-weiler[punkt]de - auch wenn ihr einfach nur Hallo sagen wollt!</p>

        <p>Wir wünschen euch viel Erfolg bei den Wettkämpfen und freuen uns auf viele Teilnehmer bei den Veranstaltungen.</p>

        <img src={Logo} className="img-fluid rounded mx-auto d-block" alt="Logo des Turnvereins Weiler i.d.B." />
      </div>
    </div>
  );
}

export default Welcome;


// WEBPACK FOOTER //
// ./src/components/Welcome.js